<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Fnnurr/tc-custom/9780226734828.jpg?1728327144544" alt="This image is the cover for the book Capitalism and Freedom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Capitalism and Freedom
      </h1>
      <p class="bookDescription body article font2">
        <b>One of the most significant works of economic theory ever written, from the “outstanding [and] unfailingly enlightening” Milton Friedman (<i>Newsweek</i>).</b><br/><br/>One of <i>Time</i> magazine’s All-Time 100 Best Nonfiction Books<br/><br/>One of <i>Times Literary Supplement</i>’s 100 Most Influential Books Since the War<br/><br/>One of <i>National Review</i>’s 100 Best Nonfiction Books of the Century<br/><br/>One of Intercollegiate Studies Institute’s 50 Best Books of the 20th Century<br/><br/>How can we benefit from the promise of government while avoiding the threat it poses to individual freedom? In this classic book, Milton Friedman provides the definitive statement of an immensely influential economic philosophy—one in which competitive capitalism serves as both a device for achieving economic freedom and a necessary condition for political freedom.<br/><br/>First published in 1962, Friedman’s <i>Capitalism and Freedom</i> is one of the most significant works of economic theory ever written. Enduring in its eminence and esteem, it has sold nearly a million copies in English, has been translated into eighteen languages, and continues to inform economic thinking and policymaking around the world. This new edition includes prefaces written by Friedman for both the 1982 and 2002 reissues of the book, as well as a new foreword by Binyamin Appelbaum, lead economics writer for the <i>New York Times</i> editorial board.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Milton Friedman, Binyamin Appelbaum
      </h2>
      
      <p class="authorDescription body article"><B>Milton Friedman</B> (1912–2006), Nobel Prize winner for excellence in economics, was a senior research fellow at the Hoover Institution, Stanford University, and the Paul Snowden Distinguished Service Professor Emeritus of Economics at the University of Chicago. His many published books include <I>Essays in Positive Economics</I>, <I>Monetary Trends in the United States and the United Kingdom</I>, and <I>Milton Friedman on Economics</I>, all published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dbbdf29e